import { select, Store } from '@ngrx/store';
import { combineLatest, map, Observable, skipUntil } from 'rxjs';
import { SafeAttachmentPolicy } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/safe-attachment-policy/model';
import { client } from 'projects/angular-clarity/src/app/stores/client';
import { selectSwaySpecStatus } from 'projects/angular-clarity/src/app/stores/root.store';

export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://docs.microsoft.com/en-us/microsoft-365/security/office-365-security/safe-attachments-about';

export { buildSafeAttachmentPolicySchema } from 'projects/angular-clarity/src/app/modules/sway/models/baseline-schemas/safe-attachment-policy.schema';

export function selectSafeAttachmentPolicy(store: Store, tenant: string): Observable<SafeAttachmentPolicy[]> {
    const baseline$ = store.pipe(select(client(tenant).sway.baselines.bySpecTag('SafeAttachmentPolicy')));
    const policies$ = store.pipe(select(client(tenant).powershell.safeAttachmentPolicy.all));

    const baselineStatus$ = store.pipe(select(client(tenant).sway.baselines.status));
    const swayStatus$ = store.pipe(select(selectSwaySpecStatus));
    const policiesStatus$ = store.pipe(select(client(tenant).powershell.safeAttachmentPolicy.status));

    // const policies$ = select(client(tenant).graph.compliancePolicies.windows10.all);

    const ready$ = combineLatest([baselineStatus$, swayStatus$, policiesStatus$]).pipe(
        map((statuses) => statuses.every((status) => status.loaded)),
    );

    return combineLatest([policies$, baseline$]).pipe(
        skipUntil(ready$),
        map(([policies, baseline]) => {
            if (!baseline) return [];
            const key = baseline.key;

            if (key) {
                const policy = policies.find((res) => res?.Identity === key);

                return policy ? [policy] : [];
            } else {
                const Identity = baseline?.schema?.contains?.properties?.Identity?.const;
                const policy = policies.find((res) => res?.Identity === Identity);
                return policy ? [policy] : [];
            }
        }),
    );
}
